var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiEsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8333 39.2083C73.4229 39.2083 70.9592 43.5883 71.9629 46.8428L61.165 57.6712C60.2525 57.3974 58.9142 57.3974 58.0017 57.6712L50.2454 49.9149C51.2796 46.6603 48.8158 42.2499 44.375 42.2499C39.9646 42.2499 37.4704 46.6299 38.5046 49.9149L24.6346 63.7545C21.38 62.7508 17 65.2145 17 69.6249C17 72.9708 19.7375 75.7083 23.0833 75.7083C27.4937 75.7083 29.9575 71.3283 28.9537 68.0737L42.7933 54.2037C43.7058 54.4774 45.0442 54.4774 45.9567 54.2037L53.7129 61.9599C52.6787 65.2145 55.1425 69.6249 59.5833 69.6249C63.9937 69.6249 66.4879 65.2449 65.4537 61.9599L76.2821 51.162C79.5367 52.1658 83.9167 49.702 83.9167 45.2916C83.9167 41.9458 81.1792 39.2083 77.8333 39.2083Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.583 42.25L62.4422 35.9537L68.708 33.125L62.4422 30.2963L59.583 24L56.7847 30.2963L50.458 33.125L56.7847 35.9537L59.583 42.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6042 48.3333L26.125 42.25L32.2083 40.7292L26.125 39.2083L24.6042 33.125L23.0833 39.2083L17 40.7292L23.0833 42.25L24.6042 48.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEsg);
export default __webpack_public_path__ + "static/media/ai_esg.54e9026bd6b0356b891c644501eaab94.svg";
export { ForwardRef as ReactComponent };